export default __webpack_public_path__ + "locales/fr/BackupCodesDialog.json?hash=3f7794aa2b509eb80d50db7539e09472";